module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Temperature trend","subTitle":"Graph relating to the trend of the temperature detected by the sensor in the selected time period."},"it":{"title":"Andamento delle temperature","subTitle":"Grafico relativo all’andamento della temperatura rilevata dal sensore nel periodo di tempo selezionato."}}')
  delete Component.options._Ctor
}
